import React from 'react';
import { Container, Row, Col, Card, Button, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <Container>
      <div className="text-center mb-5">
        <Image 
          src="https://redbeardpi.com/images/black-logo.png" 
          alt="FaceAI Logo" 
          className="logo-img mb-3" 
          style={{ maxWidth: '200px', height: 'auto' }}
        />
        <h1 className="display-6 mb-3">FaceAI Tools</h1>
        <p className="lead">Advanced AI-Powered Image Analysis</p>
      </div>

      <Row className="g-4 justify-content-center">
        <Col md={6} lg={3}>
          <Card className="h-100 shadow-sm">
            <Card.Body className="d-flex flex-column">
              <Card.Title className="text-center">Image Analysis</Card.Title>
              <Card.Text>
                Upload images for detection, face analysis, and text recognition.
              </Card.Text>
              <div className="mt-auto text-center">
                <Button as={Link} to="/image-analysis" variant="outline-primary">
                  Image Analysis
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} lg={3}>
          <Card className="h-100 shadow-sm">
            <Card.Body className="d-flex flex-column">
              <Card.Title className="text-center">Face Comparison</Card.Title>
              <Card.Text>
                Compare faces between images and search for similar faces.
              </Card.Text>
              <div className="mt-auto text-center">
                <Button as={Link} to="/face-comparison" variant="outline-danger">
                  Face Comparison
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} lg={3}>
          <Card className="h-100 shadow-sm">
            <Card.Body className="d-flex flex-column">
              <Card.Title className="text-center">Face Search</Card.Title>
              <Card.Text>
                Upload images to search by face within a dataset of collected faces.
              </Card.Text>
              <div className="mt-auto text-center">
                <Button as={Link} to="/face-collection-search" variant="outline-info">
                  Face Search
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <div className="text-center mt-5">
        <p className="text-muted">Powered by Redbeard Intelligence & Investigations</p>
      </div>
    </Container>
  );
};

export default Home;